/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Edit_SaveInputs */

const es_user_profile_edit_save = /** @type {(inputs: User_Profile_Edit_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar cambios`)
};

const en_user_profile_edit_save = /** @type {(inputs: User_Profile_Edit_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save changes`)
};

/**
* | output |
* | --- |
* | "Save changes" |
*
* @param {User_Profile_Edit_SaveInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_edit_save = /** @type {((inputs?: User_Profile_Edit_SaveInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Edit_SaveInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_edit_save(inputs)
	return en_user_profile_edit_save(inputs)
});
export { user_profile_edit_save as "user.profile.edit.save" }